// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2_r_u","detailsBorder":"styles_detailsBorder__1dtro"};